import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import Collapse from 'react-collapse'
import Button from '@components/Button'

export default class Search extends Component {
  constructor(props) {
    super(props)
    this.$inputRef = createRef()
  }

  onFinishedAnimating = () => {
    const { isExpanded } = this.props
    if (isExpanded && this.$inputRef.current) {
      this.$inputRef.current.focus()
    }
  }

  handleCloseBtnClick = e => {
    const { onClose } = this.props
    e.preventDefault()
    onClose()
  }

  render() {
    const { isExpanded } = this.props
    const backgroundStyle = {
      background:
        "url('https://www.google.com/cse/static/en/google_custom_search_watermark.gif') left center no-repeat rgb(255, 255, 255)",
    }
    const blockStyle = { display: 'block' }

    return (
      <Collapse isOpened={isExpanded} onRest={this.onFinishedAnimating}>
        <div className="container has-bg">
          <div className="search-dropdown p" style={blockStyle}>
            <Button className="button-reset search-dropdown__dismiss" onClick={this.handleCloseBtnClick}></Button>
            <form action="/search/timelines" id="cse-search-box">
              <input type="hidden" name="cx" value="partner-pub-3637961829875093:ehixnl-dg1y"></input>
              <input type="hidden" name="cof" value="FORID:9"></input>
              <input type="hidden" name="ie" value="UTF-8"></input>
              <input
                type="text"
                name="q"
                size="20"
                placeholder="Search published timelines"
                ref={this.$inputRef}
                style={backgroundStyle}
              ></input>
              <input type="submit" name="sa" value="Search" className="btn btn--primary btn--bold"></input>
              <input name="siteurl" type="hidden" value="localhost/"></input>
              <input name="ref" type="hidden" value="localhost/categories"></input>
              <input name="ss" type="hidden" value=""></input>
            </form>
            <script async src="//www.google.com/coop/cse/brand?form=cse-search-box&amp;lang=en"></script>
          </div>
        </div>
      </Collapse>
    )
  }
}
Search.defaultProps = {
  onClose: noop,
}
Search.propTypes = {
  onClose: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
}
